import { Injectable, ComponentFactoryResolver, Type } from '@angular/core';
import { ShellService } from '~core/services';

@Injectable()
export class ModalService {
  constructor(private cfr: ComponentFactoryResolver, private shell: ShellService) { }

  getModalComponent(componentType: Type<any>, params = {}): Promise<any> {
    const factory = this.cfr.resolveComponentFactory(componentType);
    const vcr = this.shell.getRootElement();
    const component = vcr.createComponent(factory);

    component.instance.subscriptions.push(component.instance.close
      .take(1)
      .subscribe(() => component.destroy()));

    return component.instance.open(params);
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/auth/services/modal.service.ts